const SESSION_KEY = 'sessionId';

export function saveSessionId(sessionId?: string | null) {
  if (sessionId) localStorage.setItem(SESSION_KEY, sessionId);
}

export function getSessionId(): string | null {
  return localStorage.getItem(SESSION_KEY);
}

export function clearSessionId() {
  localStorage.removeItem(SESSION_KEY);
}
